import { useQuery } from "@tanstack/react-query";
import { getServices } from "../../apiServices/apiServices";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function useGetServices() {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category_id");
  const { i18n } = useTranslation();

  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: ["services", categoryId, i18n.language],
    queryFn: () => getServices(categoryId),
    retry: 1,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  return { services: data, isLoading: isLoading || isFetching, error };
}
